require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-the-livid-2004.json") })
        }
      }, "path---projects-the-livid-2004");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-the-livid-2004!./.cache/json/projects-the-livid-2004.json
// module id = 532
// module chunks = 231608221292675